// extracted by mini-css-extract-plugin
export var pageContainer = "styles-module--pageContainer--1dyuy";
export var pageContent = "styles-module--pageContent--3a_qW";